export default {"src":"/_next/static/media/little-slope.1d691c84.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};